import { render, staticRenderFns } from "./ModalConfirmSubmit.vue?vue&type=template&id=64ae327a&scoped=true&"
import script from "./ModalConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmSubmit.vue?vue&type=style&index=0&id=64ae327a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae327a",
  null
  
)

export default component.exports